
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-monitors",
  components: {},
})
export default class IconMonitors extends Vue {
  @Prop() public width!: number;
  @Prop() public height!: number;
  @Prop() public color!: string;

  constructor() {
    super();
  }
}
